import { AfterViewInit, Directive, input } from '@angular/core';

@Directive({
  selector: '[ebeihilfeScrollToElement]',
  standalone: true,
})
export class ScrollToTopElementDirective implements AfterViewInit {
  public readonly scrollToElement = input<string>();
  public ngAfterViewInit(): void {
    const selector = this.scrollToElement();
    if (selector) {
      const el = document.querySelector(selector);
      if (el) {
        el.scrollTop = 0;
      }
    } else {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }, 50);
    }
  }
}
